<template>
    <Vue-Good-Table
        :rows="rows"
        :columns="columns"
        :search-options="{
            enabled: true,
            skipDiacritics: true,
        }"
        style-class="vgt-table striped"
    >
        <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'links'" class="flex items-center">
                <Table-Links :row="props.row" @delete="deleteRow(props.row)" />
            </div>
        </template>
    </Vue-Good-Table>
</template>

<script>
    import axios from 'axios';
    import { VueGoodTable } from 'vue-good-table';

    import TableLinks from './TableLinks';

    export default {
        name: 'CustomersTable',
        components: {
            VueGoodTable,
            TableLinks,
        },
        data() {
            return {
                rows: [],
                columns: [
                    {
                        label: 'Naam',
                        field: 'name',
                        sortable: true,
                    },
                    {
                        label: 'Aanmaakdatum',
                        field: 'created_at',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'yyyy-MM-dd',
                        sortable: true,
                    },
                    {
                        label: 'Acties',
                        field: 'links',
                    },
                ],
            };
        },
        created() {
            this.getRows();
        },
        methods: {
            getRows() {
                axios.get(this.route('api.customers.index'))
                    .then(({ data }) => {
                        this.rows = data.data;
                    });
            },
            async deleteRow(customer) {
                if (confirm('Please confirm')) { // eslint-disable-line
                    try {
                        await axios.delete(this.route('api.customers.destroy', customer.id));
                        const indexToDelete = this.rows.findIndex(row => row.id === customer.id);
                        if (indexToDelete !== -1) {
                            this.rows.splice(indexToDelete, 1);
                        }
                    } catch (error) {
                        console.log(error.response);
                    }
                }
            },
        },
    };
</script>
